<template>
  <omint-page-content>
    <div class="form-email-box">
      <OmtTypography
        as="h1-bold"
        mb="16px"
        >Cadastre um e-mail</OmtTypography
      >
      <OmtTypography
        as="h3-semi-bold"
        mb="32px"
      >
        Cadastre o e-mail para seguir com o fluxo do primeiro acesso.
      </OmtTypography>

      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray2)"
        >E-mail:</OmtTypography
      >
      <OmtInput
        v-model="newMail"
        mb="5"
      />
    </div>

    <OmtButton
      variant="solid"
      width="100%"
      height="50px"
      border="0.5px solid var(--colors-light-secondary-divider)"
      borderRadius="40px"
      data-cy="button-entrar"
      :disabled="!newMail.includes('@')"
      mb="3"
      @click="handleClick()"
    >
      <OmtTypography
        as="h1-bold"
        color="white"
        >Continuar</OmtTypography
      >
    </OmtButton>
  </omint-page-content>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapActions, mapState } from "vuex";

export default {
  name: "MailForm",
  data() {
    return {
      newMail: ""
    };
  },
  mounted() {
    if (!this.hash || !this.autenticado) {
      this.$router.replace({ name: "first-access.terms" });
      return;
    }
    this.$root.$emit("change-title-label", "Cadastro de Email");
  },
  computed: {
    ...mapState("firstAccess", ["autenticado", "hash"])
  },
  methods: {
    ...mapActions("firstAccess", ["addEmail"]),
    async handleClick() {
      await this.$root.$emit("show-loading");
      const error = await this.addEmail({
        email: this.newMail
      });
      await this.$root.$emit("hide-loading");
      if (error === "") {
        await this.$router.push({ name: "first-access.password" });
      } else {
        Swal.fire({
          title: "Aviso",
          text: error,
          confirmButtonText: "Tentar novamente"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-email-box {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
